export default {
    /**
     * Datos añadidos a data por el mixin:
     * - cnaeSubgroupsTypesOptions: array con tipos de subgrupos cnae
     *
     * @return {Object} Data del mixin
     */
    data() {
        return {
            selectedGroup: null
        };
    },
    computed: {
    /**
     * Antes de montar el componente se cargan los tipos de vías en la variable
     * `this.cnaeSubgroupsTypesOptions`
     * @return {Object} array
     */
        cnaeSubgroupsTypesOptions() {
            if (this.formattedData.cnae_group) {
                const cnaeSubgroupsTypes = this.$t(`interveners.cnae_subgroups.${this.formattedData.cnae_group.key}`);
                return Object.entries(cnaeSubgroupsTypes).map(item => {
                    return {
                        key: item[0],
                        name: item[1]
                    };
                });
            } else {
                return [];
            }
        }
    }
};
